import styled from 'styled-components';

export const ExpandedRowMaintenanceWrapper = styled.div`
  background: var(--neutral_lightest) !important;
  padding: 12px 24px;
  border-radius: 0 0 5px 5px;
`;
